import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import type { StpInstance } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { Button } from 'components/Button/Button';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { updateStpInstance } from 'components/Graph/commands/updateStpInstance';
import { useLocale } from 'containers/App/LocaleContext';
import { useMemo } from 'react';
import type { FC } from 'react';
import type { StpInstanceData } from './useStpInstances';

interface Props {
  instanceData: StpInstanceData;
  instances: StpInstance[];
}

export const GraphStpInstance: FC<Props> = (props) => {
  const msg = useLocale();
  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
  });

  const instance = useMemo(() => {
    return (
      props.instances.find(
        ({ vlanId, rootId }) =>
          vlanId === props.instanceData.vlanId &&
          rootId === props.instanceData.rootId,
      ) ?? {
        rootId: props.instanceData.rootId,
        vlanId: props.instanceData.vlanId,
        visible: false,
        grouped: true,
      }
    );
  }, [props.instances, props.instanceData.rootId, props.instanceData.vlanId]);

  const handleGroupButtonClick = () => {
    ctxProps.dispatch(updateStpInstance, {
      instance: { ...instance, grouped: !instance.grouped },
    });
  };

  const handleVisibleButtonClick = () => {
    ctxProps.dispatch(updateStpInstance, {
      instance: { ...instance, visible: !instance.visible },
    });
  };

  return (
    <div className='graph-stp-instance flex'>
      <div className='flex flex-1'>
        <div className='flex-1'>
          <div
            className='graph-stp-instance-vlan-name'
            title={props.instanceData.vlanName}
          >
            {props.instanceData.vlanName}
          </div>
          <div>{props.instanceData.vlanId}</div>
        </div>
        <div className='flex-1'>
          <div
            className='graph-stp-instance-root-hostname'
            title={props.instanceData.rootHostname}
          >
            {props.instanceData.rootHostname}
          </div>
          <div>{props.instanceData.rootId}</div>
        </div>
      </div>
      <Tooltip
        content={
          msg.canvasGraph.graphSidePanel.layoutSettings.protocolControls
            .grouping
        }
      >
        <Button
          variant='tertiary'
          className='mx-2'
          onClick={handleGroupButtonClick}
          type='button'
          size='xxxs'
          disabled={!instance.visible}
          icon={instance.grouped ? 'fa-link' : 'fa-unlink'}
        />
      </Tooltip>
      <Tooltip
        content={
          msg.canvasGraph.graphSidePanel.layoutSettings.protocolControls
            .visibility
        }
      >
        <Button
          variant='tertiary'
          className='mx-2'
          onClick={handleVisibleButtonClick}
          type='button'
          size='xxxs'
          icon={instance.visible ? 'fa-eye' : 'fa-eye-slash'}
        />
      </Tooltip>
    </div>
  );
};
